import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import store from '@/store'
import iView from 'view-design'
import { setToken, getToken, canTurnTo } from '@/libs/util'
import config from '@/config'
const { homeName } = config

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'
const REGISTER_PAGE_NAME = 'register'
const forgetpwd_NAME = 'forgetpwd'
// const homeName = 'home'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  // console.log(token)
  if (
    !token &&
    to.name !== LOGIN_PAGE_NAME &&
    to.name != REGISTER_PAGE_NAME &&
    to.name != forgetpwd_NAME &&
    to.name != homeName
  ) {
    // 未登录且要跳转的页面不是登录页,忘记密码，注册页面，首页
    if (to.name == 'shareholder' || to.name == 'supportself') {
      sessionStorage.setItem('goPage', to.name)
    }
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (
    (!token && to.name === LOGIN_PAGE_NAME) ||
    (!token && to.name === REGISTER_PAGE_NAME) ||
    (!token && to.name === forgetpwd_NAME) ||
    (!token && to.name === homeName)
  ) {
    // 未登陆且要跳转的页面是登录页，忘记密码，注册页面，首页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    // iView.Message.error('已登录，请先退出后再登录新账号')
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    // if (store.state.user.hasGetInfo) {
    // TODO 跳转无权限页面回到当前页并提示不可跳转
    if (
      localStorage.getItem('userData') &&
      localStorage.getItem('siderList') &&
      localStorage.getItem('siderList') !== '[]'
    ) {
      next() // 跳转

      sessionStorage.removeItem('goPage')
    } else {
      // store
      //   .dispatch('getUserInfo')
      //   .then(user => {
      //     next({
      //       name: homeName // 跳转到homeName页
      //     })
      //     // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
      //     // turnTo(to, store.state.user.access, next)
      //   })
      //   .catch(ex => {
      //     console.log('sssssssssss')
      //     //  TODO ?
      setToken('')
      sessionStorage.clear()
      localStorage.clear()
      iView.Message.error('请重新登录')
      next({
        name: LOGIN_PAGE_NAME
      })
      //   })
    }
  }
})

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
